import React from "react";
import { Trans, useTranslation } from "react-i18next";
import AppConfig from "util/AppConfig";
import { Alert } from "components/bootstrap";
import { Link } from "components/common";
import Routes from "routing/Routes";
import useForwardersConfiguration from "forwarder/wizard/select-forwarder-step/hooks/useForwardersConfiguration";
const ForwarderInputInformation = ({ forwarderInputs = [] }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { data, isLoading } = useForwardersConfiguration();
  if (AppConfig.isCloud() || (data == null ? void 0 : data.forwarder_service_autostart) || isLoading) {
    return null;
  }
  if (forwarderInputs.length === 0) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "input_information.no_input",
        components: { inputsLink: /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.INPUTS }) }
      }
    ));
  }
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "input_information.using_input",
      values: { title: forwarderInputs[0].title },
      components: { em: /* @__PURE__ */ React.createElement("em", null) }
    }
  ));
};
export default ForwarderInputInformation;
